module.exports = require("@hsq/magic-loc");